import { VueTemplate } from '../VueTemplate';
import { VueTemplateVersionInfo } from '../types';
import { SocialMediaRenderContext } from '../../../Widget/SocialMedallionWidget/types';

/**
 * Template class for socialmedia templates created using Vue
 */
export class VueSocialmediaTemplate extends VueTemplate<SocialMediaRenderContext> {
    /**
     * Expected format of the dataStore
     *
     * All dataStore for Socialmedia template must be of this format so that
     * templates are consistent
     * @see [Vue Prop Validation]{@link https://vuejs.org/v2/guide/components-props.html#Prop-Validation}
     */
    properties = {
        wid: String,
        wobj: Object,
        bodywidth: Number,
        posts: Array,
        medallion: Object,
        Zone: Object,
        zone: Object,
        Widget: Object,
        widget: Object,
        metadata: Object,
    };

    constructor(template: VueTemplateVersionInfo, wrapper: HTMLDivElement) {
        super(template, wrapper);
    }
}
